import React from 'react';
import '../template-file-css/document-file-template.css';


export const ATC_BpsAdult = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ATC_BpsAdult' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Start Time:</span>
                            <input type='time' id="txtStartTime" name="txtStartTime" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>End Time:</span>
                            <input type='time' id="txtEndTime" name="txtEndTime" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Code/Modifiers:</span>
                            <input type='text' id="txtCodeModifiers" name="txtCodeModifiers" className='add-only w-375' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Units:</span>
                            <input type='text' id="txtUnits" name="txtUnits" className='add-only w-375' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Interview:</span>
                            <input id="txtInterviewDate" name="txtInterviewDate" type='date' className='add-only w-375' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Interviewer:</span>
                            <input type='text' id="txtInterviewer" name="txtInterviewer" className='add-only w-375' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Client's Name:</span>
                            <input type='text' id="txtClientsName" name="txtClientsName" className='add-only w-375' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Referral Source:</span>
                            <input type='text' id="txtReferralSource" name="txtReferralSource" className='add-only w-375' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>DOB:</span>
                            <input type='date' id="txtDOB" name="txtDOB" className='add-only w-375' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Age:</span>
                            <input type='text' id="txtAge" name="txtAge" className='add-only w-375' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Race:</span>
                            <input type='text' id="txtRace" name="txtRace" className='add-only w-375' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Sex:</span>
                            <input type='text' id="txtSex" name="txtSex" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Identity Expression:</span>
                            <select id="ddl_100" name="ddl_100" className='add-only  w-375'>
                                <option value="0"></option>
                                <option value="a">A. Male</option>
                                <option value="b">B. Female</option>
                                <option value="c">C. Gender Expansive</option>
                                <option value="d">D. Other</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Birth Order:</span>
                            <input type='text' id="txtBirthOrder" name="txtBirthOrder" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>SSN:</span>
                            <input type='text' id="txtSSN" name="txtSSN" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Medicaid (Type):</span>
                            <input type='text' id="txtMedicaid" name="txtMedicaid" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Marital Status:</span>
                            <select id="ddlMaritalStatus" name="ddlMaritalStatus" className='add-only'>
                                <option value=""></option>
                                <option value="1">Married</option>
                                <option value="2">Single</option>
                                <option value="3">Divorce</option>
                                <option value="4">Seperated</option>
                                <option value="5">Widow</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Spouse/Significant Other:</span>
                            <input type='text' id="txtSpouse" name="txtSpouse" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>DOB:</span>
                            <input type='date' id="txtSpouseDOB" name="txtSpouseDOB" className='add-only' />
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Informant(s) Name and Relationship to Client:</span>
                            <input type='text' id="txtInformantInfo" name="txtInformantInfo" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Employer:</span>
                            <input type='text' id="txtEmployer" name="txtEmployer" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Telephone Number:</span>
                            <input type='text' id="txtPhoneNumber" name="txtPhoneNumber" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Reason for Assessment/Presenting Problems:</span>
                            <span className='small'>Brief statement of mental health symptoms; conduct; behaviors
                                and concerns that would justify a referral for intensive services; define what client
                                wants to gain from services.</span>
                            <textarea id="txtReasonForProblems" name="txtReasonForProblems" className='small'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Address/How Long There:</span>
                            <textarea id="txtAddress" name="txtAddress" className='small'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone (Home):</span>
                            <input type='text' id="txtPhoneH" name="txtPhoneH" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone (Cell):</span>
                            <input type='text' id="txtPhoneC" name="txtPhoneC" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone (MW):</span>
                            <input type='text' id="txtPhoneMW" name="txtPhoneMW" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone (FW):</span>
                            <input type='text' id="txtPhoneFW" name="txtPhoneFW" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Household Composition:</span> <span className='small'>
                                For each person in the household, include: 1) name, 2) relationship, 3) DOB/Age,
                                4) Occupation. List anyone that moves in and out of home.</span>
                            <textarea id="txtHouseholdComposition" name="txtHouseholdComposition" className='small'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Family's Income/Debt:</span> <span className='small'>
                                List family's source(s) of income. Able to meet expenses? Current debt? Frequent
                                job changes?</span>
                            <textarea id="txtIncomeDebt" name="txtIncomeDebt" className='small'></textarea>
                        </td>
                    </tr>
                </table>
                <h3>Military History</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>1. Are you currently/previously involved?</span>
                            <input type="radio" id="rb_01_1" name="rb_01" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rb_01_2" name="rb_01" className='add-only' value="2" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>2. Which branch?</span>
                            <input type='text' id="txt_01" name="txt_01" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>3. How many years of service?</span>
                            <input type='text' id="txt_02" name="txt_02" className='add-only' />
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>4. Are you currently Active Duty, Reserves, or Veteran?</span>
                            <input type="radio" id="rb_02_1" name="rb_02" className='add-only' value="1" /> Active Duty &nbsp;
                            <input type="radio" id="rb_02_2" name="rb_02" className='add-only' value="2" /> Reserves &nbsp;
                            <input type="radio" id="rb_02_3" name="rb_02" className='add-only' value="3" /> Veteran
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>5. Have you fought in any current/previous war(s)?</span>
                            <input type="radio" id="rb_03_1" name="rb_03" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rb_03_2" name="rb_03" className='add-only' value="2" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If yes, which war?</span>
                            <input type='text' id="txt_03" name="txt_03" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>6. Any current/past medical/health/mental issues?</span>
                    <span className='small'>If yes, provide a brief summary of issues below.</span>
                    <input type="radio" id="rb_04_1" name="rb_04" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rb_04_2" name="rb_04" className='add-only' value="2" /> No <br />
                    <textarea id="txt_04" name="txt_04" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Last Physical:</span>
                            <input id="txtLastPhysical" name="txtLastPhysical" type='date' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of Physician:</span>
                            <input type='text' id="txtPhysicianName" name="txtPhysicianName" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Physician Address:</span>
                            <input type='text' id="txtPhysicianAddress" name="txtPhysicianAddress" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Physician Phone:</span>
                            <input type='text' id="txtPhysicianPhone" name="txtPhysicianPhone" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Inform Families</span> <span className='small'>Inform
                                families that nursing and physician assessment will be scheduled prior to services
                                being rendered.</span>
                            <select id="ddlInformFamilies" name="ddlInformFamilies" className='add-only'>
                                <option value=""></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Nurse:</span>
                            <input type='text' id="txtInformNurse" name="txtInformNurse" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Physician:</span>
                            <input type='text' id="txtInformPhysician" name="txtInformPhysician" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Last Dental:</span>
                            <input id="txtLastDental" name="txtLastDental" type='date' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of Dentist:</span>
                            <input type='text' id="txtNameOfDentist" name="txtNameOfDentist" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Are there any current medical/dental complaints?:</span>
                            <textarea id="txtCurrentCompaints" name="txtCurrentCompaints" className='small'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Are there any current medications/prescribing physician?:</span>
                            <textarea id="txtMedsPhysician" name="txtMedsPhysician" className='small'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>List previous psychotropic medications prescribed (length/dates
                                of usage/impact):</span>
                            <textarea id="txtPsychotropicMeds" name="txtPsychotropicMeds" className='small'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Last Psychological:</span>
                            <input id="txtLastPsycho" name="txtLastPsycho" type='date' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Completed By:</span>
                            <input type='text' id="txtPsychologicalCompletedBy" name="txtPsychologicalCompletedBy" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Address and Phone Number of Agency:</span>
                            <textarea id="txtAgencyInfo" name="txtAgencyInfo" className='small'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <h5>
                                Family Dynamics</h5>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>History of Relationships:</span> <span className='small'>
                                Include history of relationships; how problems have been handled; safety issues;
                                domestic violence; custody and abuse.</span>
                            <textarea id="txtRelationshipHistory" name="txtRelationshipHistory" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Community Agency Involvement:</span> <span className='small'>
                                Describe "past" and "recent" involvement with community agencies (DFCS, Criminal
                                Justice, etc. - list contact person, phone number and time period).</span>
                            <textarea id="txtCommunityAgencyInvolvement" name="txtCommunityAgencyInvolvement"
                                className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Major Family Stressors:</span> <span className='small'>
                                Have their been any major family stressors in the past six months (family separation,
                                financial, marital, health, moves, and/or death of significant other)?</span>
                            <textarea id="txtFamilyStressors" name="txtFamilyStressors" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>History of Mental Health:</span> <span className='small'>
                                Does the client have any history of Mental Health and/or Psychiatric Interventions?
                                (List name of provider, contact information and length of treatment.)</span>
                            <textarea id="txtMentalHealthHistory" name="txtMentalHealthHistory" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Client's Personality:</span> <span className='small'>
                                Describe client's personality as per informant (management of anger, problem solving/coping
                                skills, impulsivity, peer relationships and self-esteem.)</span>
                            <textarea id="txtClientsPersonality" name="txtClientsPersonality" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <h5>
                                General Appearance of Client (as observed)</h5>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Appearance and General Behaviors:</span>
                            <textarea id="txtGeneralBehaviors" name="txtGeneralBehaviors" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Mood and Affect:</span>
                            <textarea id="txtMoodAffect" name="txtMoodAffect" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <h5>
                                Psycho-Social</h5>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Suicidal Ideation/Self-Injurious Behavior:</span>
                            <span className='small'>List attempts, discussion of, precipitating factors in the
                                past.</span>
                            <textarea id="txtSuicidal" name="txtSuicidal" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Ideation/Behavior:</span> <span className='small'>
                                List any issues within the last six months.</span>
                            <textarea id="txtRecentSuicidal" name="txtRecentSuicidal" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Severely Aggressive Ideation(s) and/or Behavior:</span>
                            <textarea id="txtSevereIdeation" name="txtSevereIdeation" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Feelings of Persecution:</span> <span className='small'>
                                Does the client report feeling like people are "plotting against", "planning to
                                harm him" or "out-to-get" him/her?</span>
                            <textarea id="txtPersecutionFeelings" name="txtPersecutionFeelings" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Delusions/Hallucinations:</span> <span className='small'>
                                Does the client report seeing, smelling or hearing things; people; odors; or sounds
                                that others don't?</span>
                            <textarea id="txtDelusions" name="txtDelusions" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Obsessive/Compulsive Behaviors:</span> <span className='small'>
                                Does the client regularly engage in "non-sense" type actions that are extreme and
                                not necessary?</span>
                            <textarea id="txtObsessive" name="txtObsessive" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Dissociation/Post-Traumatic Stress Disorder:</span>
                            <textarea id="txtDissociation" name="txtDissociation" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>History of Temper-tantrums/Rapid Mood Swings:</span>
                            <textarea id="txtMoodSwingHistory" name="txtMoodSwingHistory" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <h5>
                                Developmental History</h5>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Planned vs. Unplanned Pregnancy:</span>
                            <textarea id="txtPregnancy" name="txtPregnancy" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Delivery:</span> <span className='small'>Full-term?
                                Any complications?</span>
                            <textarea id="txtPreggoDelivery" name="txtPreggoDelivery" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Drug or Alcohol Use During Pregnancy:</span>
                            <textarea id="txtDrugAlcoholPreggoUse" name="txtDrugAlcoholPreggoUse" className='small'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Developmental Milestones:</span> <span className='small'>
                                Age of walking, talking, toilet trained, speech development, etc.</span>
                            <textarea id="txtDevMilestones" name="txtDevMilestones" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <h5>
                                General Functioning</h5>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Describe Sleep Patterns:</span>
                            <textarea id="txtSleepPatterns" name="txtSleepPatterns" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Describe Eating Habits:</span>
                            <textarea id="txtEatingHabits" name="txtEatingHabits" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Use of Addictive Substances:</span> <span className='small'>
                                Status of client's use of addictive substances; history of parent/significant other's
                                use.</span>
                            <textarea id="txtAddictiveSubstances" name="txtAddictiveSubstances" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>History of Criminal Behavior:</span>
                            <textarea id="txtCriminalBehavior" name="txtCriminalBehavior" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>History of Significant Illnesses:</span> <span className='small'>
                                Include history for client, parent and/or significant other.</span>
                            <textarea id="txtSignificantIllness" name="txtSignificantIllness" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Significant Family Medical and/or Psychiatric History:</span>
                            <textarea id="txtFamilyMedPsychHistory" name="txtFamilyMedPsychHistory" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Describe Relationship to Sibling(s) and Spouse/Significant
                                Other:</span>
                            <textarea id="txtRelationships" name="txtRelationships" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Describe Relationship with Peers:</span> <span className='small'>
                                Best friend? Same/opposite sex?</span>
                            <textarea id="txtPeerRelationships" name="txtPeerRelationships" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Relationship with Significant Other/Support System:</span>
                            <textarea id="txtSupportSystemRelationship" name="txtSupportSystemRelationship" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Any Special Interests or Hobbies:</span>
                            <textarea id="txtHobbies" name="txtHobbies" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Limited/Prohibited Contact:</span> <span className='small'>
                                Is there anyone who is prohibited with having contact with the client, or for whom
                                contact is limited?</span>
                            <textarea id="txtLimitedContact" name="txtLimitedContact" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <h5>
                                Social Stressors</h5>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Problems with Primary Support Group:</span>
                            <textarea id="txtSupportGroupProblems" name="txtSupportGroupProblems" className='small'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Problems Related to Social Environment:</span>
                            <textarea id="txtSocialEnviroProblems" name="txtSocialEnviroProblems" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Educational Problems:</span>
                            <textarea id="txtEducationalProblems" name="txtEducationalProblems" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Occupational Problems:</span>
                            <textarea id="txtOccupationalProblems" name="txtOccupationalProblems" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Housing Problems:</span>
                            <textarea id="txtHousingProblems" name="txtHousingProblems" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Economic Problems:</span>
                            <textarea id="txtEconomicProblems" name="txtEconomicProblems" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Problems with Access to Health Care Services:</span>
                            <textarea id="txtAccessToHealthCare" name="txtAccessToHealthCare" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Other Psychosocial or Environmental Problems:</span>
                            <textarea id="txtOtherProblems" name="txtOtherProblems" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Educational History:</span> <span className='small'>
                                High school graduate, post secondary education, social and community involvement.</span>
                            <textarea id="txtEducationalHistory" name="txtEducationalHistory" className='small'></textarea>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr  >
                        <td className='w-750'>
                            <h5>
                                Services Offered</h5>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Discuss all services offers families:
                            </span>
                            <span className='small'>A) IFI, B) Substance Abuse, C) Community
                                    Support Individual (CSI), D) Individual Therapy, E) Family Therapy, F) Group Session,
                                    G) Nurse Assessment, H) Physician Assessment, I) Medication Management. Review criteria
                                    for IFI and Core Services. Determine which services will be provided to families.</span>
                            <textarea id="txtServicesDiscussions" name="txtServicesDiscussions" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <h5>
                                Assessments</h5>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-375'>
                            <span className='eleHeader'>Locus Score:</span>
                            <input type='text' id="txtLocusScore" name="txtLocusScore" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>I:</span>
                            <input type='text' id="txtI" name="txtI" className='add-only' />
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-375'>
                            <span className='eleHeader'>II:</span>
                            <input type='text' id="txtII" name="txtII" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>III:</span>
                            <input type='text' id="txtIII" name="txtIII" className='add-only' />
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-375'>
                            <span className='eleHeader'>IV:</span>
                            <input type='text' id="txtIV" name="txtIV" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>VI:</span>
                            <input type='text' id="txtV" name="txtV" className='add-only' />
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-375'>
                            <span className='eleHeader'>V:</span>
                            <input type='text' id="txtVI" name="txtVI" className='add-only' />
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Implications of Psychiatric Information:</span>
                            <textarea id="txtPsychiatricImplications" name="txtPsychiatricImplications" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Diagnostic Impression</span> Based on background
                            information, test results, and behavioral observations,
                            <input type='text' id="txtDIName" name="txtDIName" className='add-only' />, presents with DSM-IV symptoms
                            of:
                            <textarea id="txtDI" name="txtDI" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-375'>
                            <span className='eleHeader'>Axis I:</span>
                            <input type='text' id="txtAxisI" name="txtAxisI" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis II:</span>
                            <input type='text' id="txtAxisII" name="txtAxisII" className='add-only' />
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-375'>
                            <span className='eleHeader'>Axis III:</span>
                            <input type='text' id="txtAxisIII" name="txtAxisIII" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis IV:</span>
                            <input type='text' id="txtAxisIV" name="txtAxisIV" className='add-only' />
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-375'>
                            <span className='eleHeader'>Axis V:</span>
                            <input type='text' id="txtAxisV" name="txtAxisV" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>GAF:</span>
                            <input type='text' id="txtGAF" name="txtGAF" className='add-only' />
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Recommendations from Evaluation:</span> <span className='small'>
                                Define the indicators that will determine when the client is ready to begin to transition
                                and identify what resources/interventions that are needed to help in successfully
                                moving the client through the process.</span>
                            <textarea id="txtEvaluationRecommendations" name="txtEvaluationRecommendations" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Who would family like to attend family conference?:</span>
                            <span className='small'>List names and contact information.</span>
                            <textarea id="txtWhoLikeToAttend" name="txtWhoLikeToAttend" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <h5>
                                Transitional Considerations</h5>
                            <p className='w-750'>
                                State issues discussed with client/parent or guardian during assessment interview
                                and throughout treatment, using the SNAP format. The acronym is specific to the
                                client and represents their current Strengths, Needs, Abilities and the Preferences
                                that would need to be accomplished/defined to determine when and how to proceed
                                with transition/discharge.</p>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Strengths:</span>
                            <textarea id="txtStrengths" name="txtStrengths" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Needs:</span>
                            <textarea id="txtNeeds" name="txtNeeds" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Abilities:</span>
                            <textarea id="txtAbilities" name="txtAbilities" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Preferences:</span>
                            <textarea id="txtPreferences" name="txtPreferences" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Interpretative/Integrated Summary:</span> <span className='small'>
                                The Summary should began with a brief description of the client; a statement that
                                integrates all assessments; an analysis of the client's perception of his/her need
                                for services; interventions that 
                                can offer and community-based needs;
                                describe central themes; reason(s) the client is seeking service; the client's acceptance
                                or understanding of his/ her problems/needs and strategies; client's apparent strengths
                                and functional limitations; description of potential barriers to treatments and
                                successful attainment of goals and movement toward success/recovery; complicating
                                conditions/ disorders, serious medical conditions; explanation of choice goals to
                                be worked on; description of risk versus choice issues. Identify whether CORE Services
                                are recommended and a concluding statement. Include reason for admission; history
                                of disorder/disability/dependency; biomedical conditions and complications; emotional/behavior/cognitive
                                conditions and complications; social/family/spiritual issues; treatment acceptance/
                                resistance; Comment on play and daily activities as indication of psychosocial development
                                and a potential medium for clinical intervention.</span>
                            <textarea id="txtIntegratedSummary" name="txtIntegratedSummary" className='small'></textarea>
                        </td>
                    </tr>
                    <tr  >
                        <td className='w-750'>
                            <span className='eleHeader'>Recommendations for Discharge Plan:</span> <span className='small'>
                                Define the indicators that will determine when the client is ready to begin to transition
                                from care and identify what resources/interventions are needed to help in successfully
                                moving the client through the process.</span>
                            <textarea id="txtEvalRecommendations" name="txtEvalRecommendations" className='small'></textarea>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr  >
                        <td className='signature w-600' > &nbsp; </td>
                        <td className='signature w-150' > &nbsp; </td>
                    </tr>
                    <tr  >
                        <td className='small w-600'> Signature of Assessor &amp; Credentials </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                </table>






            </div>
        </form>

    )
}